import { render, staticRenderFns } from "./detailRelevancyChange.vue?vue&type=template&id=7adc2036&scoped=true&"
import script from "./detailRelevancyChange.vue?vue&type=script&lang=js&"
export * from "./detailRelevancyChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7adc2036",
  null
  
)

export default component.exports